module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/201/assets/images/19158094b5114d48520aae4bc1bc93c9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_tick_active.svg
// module id = 3Y2X
// module chunks = 1